import {mapGetters, mapState} from "vuex";
import localeMixin from "./localeMixin";

export default {
  mixins: [localeMixin],

  computed: {
    ...mapGetters({
      motor: 'build/getMotor',
      tank: 'build/getTank',
      tankerFloat: 'build/getTankerFloat',
      waterAbsorbentTankAeration: 'build/getWaterAbsorbentTankAeration',
      retourFilter: 'build/getExtraProductId',
      pump: 'build/getPump',
      circuit: 'build/getCircuit',
      dynamo: 'build/getDynamo',
      powerpackOptions: 'powerpackOptions/getAll',

      lid: 'build/getLid',
      lanternPiece: 'build/getLanternPiece',
      elasticCoupling: 'build/getElasticCoupling',
      electricalBox: 'build/getElectricalBox',

      wheels: 'build/getWheels',
      cooler: 'build/getCooler',
    }),

    valves() {
      let state = this.$store.state;
      return state.build.valves.all
    },

  },

  methods: {
    formatPrice(price) {
      return (price/1).toFixed(2).replace('.', ',');
    }
  }
}
